import styled from '@emotion/styled'
import { Row } from 'antd'
import { termsStyleCss } from 'components/Common'

export const TermInfoRow = styled(Row)`
  padding: 20px 16px;
  background-color: #fafafb;
  border: 1px solid #f3f2f4;
  border-radius: 6px;

  #signee {
    margin-left: 12px;
    font-weight: 500;
    font-size: 14px;

    color: #d092dd;
  }

  strong {
    font-size: 14px;
  }
`

export const TermsGeneralSettingsRow = styled(Row)`
  overflow-y: scroll;
  max-height: calc(100vh - 210px);

  ${termsStyleCss}
`
